<template>
  <section
    class="section split"
    :class="{
      '-light': bg_color === 'light',
      '-dark': bg_color === 'dark',
      '-right': image_side === 'right' || images_side === 'right',
    }"
  >
    <div v-if="header" class="split__images">
      <LangRouterLink
        :to="{ name: 'voyage', params: { slug: voyage1.slug } }"
        class="split__image"
        v-reveal
      >
        <img
          :src="voyage1?.cover_id?.md || voyage1.map_id?.md || 'https://placehold.co/500x500'"
          alt=""
        />

        <div>
          <div class="split__image-content">
            <div class="flex">
              <Icon
                :id="voyage1.type === 'bus' ? 'autobus' : 'avion'"
                class="split__image-content-icon"
              />

              {{ voyage1.name }}
            </div>

            <div>
              {{ zone(voyage1) || voyage1.identifier }}
            </div>

            <Icon id="arrow" class="split__image-content-arrow" />
          </div>
        </div>
      </LangRouterLink>

      <LangRouterLink
        :to="{ name: 'voyage', params: { slug: voyage2.slug } }"
        class="split__image"
        v-reveal
      >
        <img
          :src="voyage2?.cover_id?.md || voyage2.map_id?.md || 'https://placehold.co/500x500'"
          alt=""
        />

        <div>
          <div class="split__image-content">
            <div class="flex">
              <Icon
                :id="voyage2.type === 'bus' ? 'autobus' : 'avion'"
                class="split__image-content-icon"
              />

              {{ voyage2.name }}
            </div>

            <div>
              {{ zone(voyage2) || voyage2.identifier }}
            </div>

            <Icon id="arrow" class="split__image-content-arrow" />
          </div>
        </div>
      </LangRouterLink>
    </div>

    <div v-else class="split__images">
      <div v-if="image1" class="split__image" v-reveal>
        <img :src="image1.original || 'https://placehold.co/500x500'" alt="" />
      </div>

      <div v-if="image2" class="split__image" v-reveal>
        <img :src="image2.original || 'https://placehold.co/500x500'" alt="" />
      </div>

      <LangRouterLink
        v-if="destination"
        :to="{ name: 'voyage', params: { slug: voyage.slug } }"
        class="split__image"
        v-reveal
      >
        <img
          :src="voyage?.cover_id?.md || voyage.map_id?.md || 'https://placehold.co/500x500'"
          alt=""
        />

        <div>
          <div class="split__image-content">
            <div class="flex">
              <Icon
                :id="voyage.type === 'bus' ? 'autobus' : 'avion'"
                class="split__image-content-icon"
              />

              {{ voyage.name }}
            </div>

            <div>
              {{ zone(voyage) || voyage.identifier }}
            </div>

            <Icon id="arrow" class="split__image-content-arrow" />
          </div>
        </div>
      </LangRouterLink>

      <div
        v-if="image"
        :class="[
          'split__image',
          {
            '-single': !destination,
            '--inverse': image_first,
          },
        ]"
        v-reveal
      >
        <img :src="image.original || 'https://placehold.co/500x500'" alt="" />
      </div>
    </div>

    <div class="split__content">
      <h2 v-if="title" class="split__content-title" v-reveal>
        {{ title }}
      </h2>

      <template v-for="(item, key) in description" :key="key">
        <div v-if="item.flexLayout === 'richtext'" v-html="item.content" class="wysiwyg" v-reveal />

        <ButtonArrow
          v-if="item.flexLayout === 'button'"
          :btn="item"
          :parent-bg-color="bg_color"
          class="wysiwyg__button"
          v-reveal
        />
      </template>
    </div>
  </section>
</template>

<script>
import ButtonArrow from '@/components/global/ButtonArrow.vue'
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'SectionSplit',

  components: {
    ButtonArrow,
    Icon,
    LangRouterLink,
  },

  props: {
    title: {
      type: String,
      default: 'Title',
    },

    image_side: {
      type: String,
      default: 'left',
    },

    images_side: {
      type: String,
      default: 'left',
    },

    bg_color: {
      type: String,
      default: 'blue',
    },

    description: {
      type: Array,
    },

    header: {
      type: Object,
      default: () => null,
    },

    image: {
      type: Object,
      default: null,
    },

    image1: {
      type: Object,
      default: null,
    },

    image2: {
      type: Object,
      default: null,
    },

    destination: {
      type: Object,
      default: null,
    },

    image_first: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    zone(voyage) {
      if (voyage.zone_id) {
        return this.$beet.destinations_zones[Number(voyage.zone_id)]?.name
      }

      return voyage.identifier
    },

    getVoyage(id) {
      return id ? Object.values(this.$beet.destinations).find((d) => d.id === id) : null
    },
  },

  computed: {
    voyage1() {
      return this.getVoyage(Number(this.header?.destination_1))
    },

    voyage2() {
      return this.getVoyage(Number(this.header?.destination_2))
    },

    voyage() {
      return this.getVoyage(Number(this.destination))
    },
  },
}
</script>
